import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
  Button,
  IconButton,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/system";
import SubmitButtonWithLoader from "../forms/SubmitButtonWithLoader";

const StyledDialog = styled(Dialog)(({ width }) => ({
  fontFamily: "Lato, sans-serif",
  "& .MuiPaper-root": {
    overflowX: "hidden",
    maxWidth: width || "520px",
    width: "100%",
    minWidth: "fit-content",
  },
}));

const StyledDialogTitle = styled(DialogTitle)(({ titleBgColor }) => ({
  backgroundColor: titleBgColor || "hsl(144, 38%, 27%)",
  color: "white",
  position: "relative",
}));

const StyledIconButton = styled(IconButton)(() => ({
  position: "absolute",
  right: 15,
  top: 8,
  color: "white",
}));

const StyledDialogContent = styled(DialogContent)(() => ({
  marginTop: "15px",
}));

const StyledDialogContentText = styled(DialogContentText)(({ singleLine }) => ({
  fontFamily: "Lato, sans-serif",
  fontSize: "18.42px",
  fontWeight: 500,
  lineHeight: "22.1px",
  textAlign: "left",
  whiteSpace: singleLine ? "nowrap" : "normal",
}));

const StyledDialogActions = styled(DialogActions)(() => ({
  marginBottom: "15px",
}));

const CustomAlert = ({
  open,
  title,
  message,
  onCancel,
  onSubmit,
  openImage,
  cancelText = "Cancel",
  submitText = "Submit",
  width = "520px",
  titleBgColor = "hsl(144, 38%, 27%)",
  cancelBtnColor = "primary",
  submitBtnColor = "primary",
  cancelBgColor = "transparent",
  submitBgColor = "primary.main",
  submitVariant = "contained",
  cancelVariant = "outlined",
  isSubmitting,
  singleLine = false,
}) => {
  const theme = useTheme();
  return (
    <StyledDialog
      open={open}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      width={width}
      fullWidth
    >
      <StyledDialogTitle id="alert-dialog-title" titleBgColor={titleBgColor}>
        {title}
        <StyledIconButton
          edge="end"
          color="inherit"
          onClick={onCancel}
          disabled={isSubmitting}
        >
          <CloseIcon />
        </StyledIconButton>
      </StyledDialogTitle>
      <StyledDialogContent>
        <StyledDialogContentText
          sx={{ color: "#302D2D" }}
          id="alert-dialog-description"
          singleLine={singleLine}
        >
          {message}
        </StyledDialogContentText>
      </StyledDialogContent>
      {!openImage && (
        <StyledDialogActions>
          <Box display="flex" justifyContent="flex-end" gap={2}>
            <SubmitButtonWithLoader
              onClick={onCancel}
              variant={cancelVariant}
              disabled={isSubmitting}
            >
              {cancelText}
            </SubmitButtonWithLoader>

            <SubmitButtonWithLoader
              loading={isSubmitting}
              onClick={onSubmit}
              type="submit"
              variant={submitVariant}
            >
              {submitText}
            </SubmitButtonWithLoader>
            {/* <Button
            onClick={onSubmit}
            variant={submitVariant}
            color={submitBtnColor}
            sx={{
              backgroundColor: submitBgColor,
              color: "white",
              borderRadius: "4px",
              width: "94px",
            }}
            size="large"
          >
            {submitText}
          </Button> */}
          </Box>
        </StyledDialogActions>
      )}
    </StyledDialog>
  );
};

export default CustomAlert;
